import axios from "axios";
import { toast } from "sonner";

// SEC-2 (2026-07-04) — was a hidden-iframe download. An iframe can't send the
// Authorization header, which forced /applications/:id/pdf to stay
// unauthenticated (anyone with a deal id could pull the full application
// PDF). Fetching via axios sends the bearer token (global default +
// impersonation interceptor), so the endpoint is now auth-gated. Public PDFs
// (e.g. /pdf/blank on the landing page) still work — no token, open endpoint.
export const downloadPdf = async (url, filename) => {
  try {
    toast.success(`Downloading ${filename}...`);
    const res = await axios.get(url, { responseType: "blob" });
    const objectUrl = window.URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = objectUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    // Revoke after the browser has had time to start the save.
    setTimeout(() => {
      try { window.URL.revokeObjectURL(objectUrl); } catch {}
    }, 60000);
  } catch (err) {
    toast.error("Download failed — please try again");
  }
};
